"use strict";

exports.__esModule = true;
exports.DsSgTimePicker = void 0;
var _react = _interopRequireDefault(require("react"));
var _components = require("@sg-bootstrap/components/dist/react-library/src/components");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// @ts-nocheck

var DsSgTimePicker = exports.DsSgTimePicker = function DsSgTimePicker(_ref) {
  var id = _ref.id,
    value = _ref.value,
    onChange = _ref.onChange,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    placeholder = _ref.placeholder,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$minuteStep = _ref.minuteStep,
    minuteStep = _ref$minuteStep === void 0 ? 1 : _ref$minuteStep;
  var handleChange = function handleChange(event) {
    if (onChange) {
      onChange(event.detail.time);
    }
  };
  var handleInvalidValue = function handleInvalidValue() {
    if (onChange) {
      onChange(undefined);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.SgTimepicker, {
    id: id,
    value: value,
    onTimeSelected: handleChange,
    onInvalidTime: handleInvalidValue,
    onInputCleared: handleInvalidValue,
    disabled: disabled,
    size: size,
    placeholder: placeholder,
    minuteStep: minuteStep
  });
};